<template>
  <component
    :is="to ? 'router-link' : 'div'"
    :to="to || undefined"
    class="kpi-card"
    :class="{ 'kpi-card--clickable': to }"
  >
    <div class="kpi-card__header">
      <span class="kpi-card__label">{{ label }}</span>
    </div>
    <div class="kpi-card__value">{{ value }}</div>
    <div v-if="sublabel" class="kpi-card__sublabel">{{ sublabel }}</div>
  </component>
</template>

<script setup>
defineProps({
  label: String,
  value: [String, Number],
  sublabel: String,
  to: { type: String, default: null },
})
</script>

<style scoped>
.kpi-card {
  flex: 1 1 0;
  min-width: 0;
  background: var(--bg-surface-1);
  border: 1px solid var(--border-active);
  border-radius: 10px;
  padding: 0.45rem 1.25rem;
  display: block;
  text-decoration: none;
  color: inherit;
}

.kpi-card--clickable {
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.kpi-card--clickable:hover {
  border-color: var(--accent-blue);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.kpi-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.kpi-card__label {
  font-size: 0.8rem;
  color: var(--text-content);
  font-family: var(--font-body);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kpi-card__value {
  font-family: var(--font-mono);
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--text-content);
}

.kpi-card__sublabel {
  font-size: 0.75rem;
  color: var(--text-content);
  margin-top: 0.2rem;
}
</style>